import React from "react";

import MTestCurve from '../marker/mTest';
import MLine from '../marker/mLine';
import MPointFix from '../marker/mPointFix';
import MPointMove from '../marker/mPointMove'
import MLineMove from '../marker/mLineMove';

import MSocket from '../marker/mSocket';
import MJoint from '../marker/mJoint';

import MarkingCommon from './markingCommon';
import Param from '../store/param';
import Control from '../store/control';



// -----------------------------------------------
// Access to the params should be centralized here and not under marker/!
// -----------------------------------------------
/**
 * This component renders different types of markings and points based on the activeStep and setup.
 * It uses various parameters and controls to determine which elements to render and how to position them.
 * @returns {JSX.Element} - The MarkingTest component.
 */
const MarkingTest = () => {
  const activeStep    = Param.Get("activeStep");
  const setup         = Param.Get("setup");
  const align         = Param.Get("align");
  const marking       = Param.Get("marking");
  const setParam      = Param.Get("setParam");
  const currentAngle  = Control.Get("currentAngle");
  const origin        = Control.Get('origin');
  const meshLeg      = Control.Get('meshLeg');
  const meshSocketCompress       = Control.Get("meshSocketCompress");
  const meshSocketModify       = Control.Get("meshSocketModify");
  const meshSocketTrim       = Control.Get("meshSocketTrim");

  const isTest       = (activeStep == 0); 
  const isMPT       = (activeStep == 1) && (align.step == 1); // for MPT
  const isCenterX   = (activeStep == 1) && (align.step == 3) && (align.stepCenter == 0); // for center x axis of leg 
  const isCenterY   = (activeStep == 1) && (align.step == 3) && (align.stepCenter == 1); // for center y axis of leg
  const isMP        = ((activeStep == 1) && (align.step == 2)) || (activeStep == 2); 
  const isPTB       = ((activeStep == 1) && (align.step == 2)); 


  const isPTBO      = (activeStep == 1) && (align.step == 2) //&& (align.stepPTB == 0); 
  const isPTBI      = (activeStep == 1) && (align.step == 2) //&& (align.stepPTB == 1); 
  const isMarking   = (activeStep == 2) // || (activeStep == 5); 
  const isMarking0  = (activeStep == 2) && (marking.target == 0); 
  const isMarking1  = (activeStep == 2) && (marking.target == 1); 
  const isMarking2  = (activeStep == 2) && (marking.target == 2);
  const isMarking3  = (activeStep == 2) && (marking.target == 3); 
  const isMarking4  = (activeStep == 2) && (marking.target == 4); 
  const isMarking5  = (activeStep == 2) && (marking.target == 5); 
  const isMarking6  = (activeStep == 2) && (marking.target == 6); 
  const isMarking7  = (activeStep == 2) && (marking.target == 7); 
  const isMarking8  = (activeStep == 2) && (marking.target == 8); 
  const isMarking9  = (activeStep == 2) && (marking.target == 9); 
  const isOutputBk     = (activeStep == 7)
  const dir         = isPTB ? "x" : "";

  /**
   * Sets the y-coordinate of the given point to the y-coordinate of the origin.
   * Determines whether to set the point as the left or right point of the PTB based on the setup side.
   * If both left and right points are null, sets the point as the left or right point based on its x-coordinate.
   * If one of the points is null, sets the point as that point.
   * If both points are not null, sets the point as the left or right point based on its distance to the existing points.
   * @param {Object} v - The point to set the y-coordinate and determine its position as the left or right point of the PTB.
   */
  const SetPointPtb = (v) => {
    v.y = 0;
    //v.y = origin.y;

    // Determine whether to set the point as the left or right point of the PTB based on the setup side.
    console.log('side: ' + setup.side)
    if (setup.side == 0) { // left
      var left = "vpt_ptbI";
      var right = "vpt_ptbO";
    } else { // right
      var left = "vpt_ptbO";
      var right = "vpt_ptbI";
    }

    // If both left and right points are null, sets the point as the left or right point based on its x-coordinate.
    if (align[left] == null && align[right] == null) {
      if (v.x < 0) {
        setParam(s => {s.align[left] = v});
      } else {
        setParam(s => {s.align[right] = v});
      }
    } else if (align[left] == null && align[right] != null) {
      setParam(s => {s.align[left] = v});
    } else if (align[left] != null && align[right] == null) {
      setParam(s => {s.align[right] = v});
    } else {
      if (v.x > align[right].x) {
        setParam(s => {s.align[right] = v});
      } else if (v.x < align[left].x) {
        setParam(s => {s.align[left] = v});
      } else {
        if (Math.abs(v.x - align[left].x) > Math.abs(v.x - align[right].x)){
          setParam(s => {s.align[right] = v});
        } else {
          setParam(s => {s.align[left] = v});
        }
      }
    }
  }

  /**
   * Sets the point mark for the current angle.
   * @param {number} v - The value to set for the point mark.
   */
  const SetPointMark = (v) => {
    if((currentAngle >= 1) && (currentAngle <= 6)){
      setParam(s => {
        s.marking.vpt[s.marking.target] = v, 
        s.marking.angle[s.marking.target] = currentAngle
      });
    }
    else
      console.warn("Can't mark in Free View");
  }
  
  return (
    <>
      <MarkingCommon/> {/* Renders the common markings. */}

      {/*
      { isTest ? <MTestCurve color={"deeppink"} axisMove={"z"} axisShow={"y"}/> : null }
      */}
      {/* { isTest     ? <MSocket
                      meshSocket={meshSocketTrim} 
                    /> : null } */}
      
      { isMPT || isPTB || isCenterX || isCenterY? <MLine color={"deeppink"} axisMove={"y"} axisShow={"x"} isCenter={true} fix={isPTB || isCenterX || isCenterY} linewidth={3} /> : null }
      { isMPT ? <MLineMove color={'dodgerblue'} axisMove={'y'} axisShow={'x'} linewidth={1} /> : null }
      
      { isCenterX ? <MLine color={"deeppink"} axisMove={"x"} isCenterX={true} axisShow={"y"} linewidth={3} /> : null }
      { isCenterX ? <MLineMove color={'dodgerblue'} axisMove={'x'} axisShow={'y'} linewidth={1} /> : null }
      { isCenterY ? <MLine color={"deeppink"} axisMove={"z"} isCenterZ={true} axisShow={"y"}linewidth={3} /> : null }
      { isCenterY ? <MLineMove color={'dodgerblue'} axisMove={'z'} axisShow={'y'} linewidth={1} side={setup.side} /> : null }
      
      {/* display MP level line */}
      { isMP      ? <MPointMove mesh={meshLeg} origin={origin} color={"blue"} dir={dir}  /> : null }
      {/* display two points of PTB */}
      { isPTB     ? <>
                      <MPointFix text={"In"} vpoint={align.vpt_ptbI} color={"blue"} isActive={isPTBI} callback={SetPointPtb}/>
                      <MPointFix text={"Out"} vpoint={align.vpt_ptbO} color={"blue"} isActive={isPTBO} callback={SetPointPtb}/>
                    </> : null }
      
      { isMarking ? <MPointFix text={"Tubercle"} vpoint={marking.vpt[0]} color={"deeppink"} isActive={isMarking0} callback={SetPointMark}/> : null }
      { isMarking ? <MPointFix text={"Condylar"} vpoint={marking.vpt[1]} color={"deeppink"} isActive={isMarking1} callback={SetPointMark}/> : null }
      { isMarking ? <MPointFix text={"End"} vpoint={marking.vpt[2]} color={"deeppink"} isActive={isMarking2} callback={SetPointMark}/> : null }
      { isMarking ? <MPointFix text={"Head"} vpoint={marking.vpt[3]} color={"orangered"} isActive={isMarking3} callback={SetPointMark}/> : null }
      { isMarking ? <MPointFix text={"End"} vpoint={marking.vpt[4]} color={"orangered"} isActive={isMarking4} callback={SetPointMark}/> : null }
      { isMarking ? <MPointFix text={"User1"} vpoint={marking.vpt[5]} color={"red"} isActive={isMarking5} callback={SetPointMark}/> : null }
      { isMarking ? <MPointFix text={"User2"} vpoint={marking.vpt[6]} color={"red"} isActive={isMarking6} callback={SetPointMark}/> : null }
      { isMarking ? <MPointFix text={"User3"} vpoint={marking.vpt[7]} color={"red"} isActive={isMarking7} callback={SetPointMark}/> : null }
      { isMarking ? <MPointFix text={"User4"} vpoint={marking.vpt[8]} color={"red"} isActive={isMarking8} callback={SetPointMark}/> : null }
      { isMarking ? <MPointFix text={"User5"} vpoint={marking.vpt[9]} color={"red"} isActive={isMarking9} callback={SetPointMark}/> : null }
    </>
  );
};

export default MarkingTest;
